let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kK6se")).then(() => parcelRequire('dr5EV'));